import { supabase } from '../../lib/supabaseClient';
import type { GeminiContent, NovaCall } from './novaLoop';

type NovaBody = { ok?: boolean; error?: string; detail?: string; text?: string; calls?: NovaCall[] };

export function novaErrorText(body: NovaBody | null, fallback: string): string {
  const detail = typeof body?.detail === 'string' ? body.detail.slice(0, 240) : '';
  const error = typeof body?.error === 'string' ? body.error : '';
  return [error, detail].filter(Boolean).join(' — ') || fallback;
}

async function readInvokeError(error: unknown): Promise<string> {
  const fallback = error instanceof Error ? error.message : 'Nova injoignable';
  const context = error && typeof error === 'object' && 'context' in error
    ? (error as { context?: unknown }).context
    : null;
  if (!(context instanceof Response)) return fallback;
  const text = await context.clone().text().catch(() => '');
  if (!text.trim()) return fallback;
  try {
    return novaErrorText(JSON.parse(text) as NovaBody, fallback);
  } catch {
    return text.slice(0, 240);
  }
}

export async function completeNovaTurn(input: {
  contents: GeminiContent[];
  state: string;
}): Promise<{ text: string; calls: NovaCall[] }> {
  const { data, error } = await supabase.functions.invoke('cime-nova', { body: input });
  if (error) throw new Error(await readInvokeError(error));
  const body = data as NovaBody | null;
  if (!body?.ok) throw new Error(novaErrorText(body, 'Nova injoignable'));
  return { text: body.text ?? '', calls: Array.isArray(body.calls) ? body.calls : [] };
}
